import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./GrantedPopup.module.css";
import { CDN_LINK } from "@globalConfig";
var GrantedPopup = function GrantedPopup() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.headSection
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/inspected-guaranteed-ar.svg",
    alt: "",
    className: "m-hide"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garnteed-program.svg",
    alt: "",
    className: "m-hide"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garntee-head-group.svg",
    alt: "",
    className: "m-show"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.point
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/guarantee-10.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("ضمان استرداد خلال 10 أيام", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("p", null, t("تقدر لأي سبب خلال 10 أيام ترجع السيارة و تسترد كامل فلوسك.", {
    ns: "web_search"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.point
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/shield.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, tShort("allUspsModal/item_two_title")), /*#__PURE__*/React.createElement("p", null, tShort("allUspsModal/item_description")))), /*#__PURE__*/React.createElement("div", {
    className: stl.point
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garnteee-check.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("فحص أكثر من 200 نقطة", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("p", null, t("نفحص سياراتنا المستعملة في أكثر من 200 نقطة والتأكد من نظافتها وأدائها.", {
    ns: "web_search"
  })))));
};
export default GrantedPopup;